// Import model
import { DataviewCatalogFeedResponse } from '../models/DataviewCatalogFeedResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CatalogFeed } from '../models/CatalogFeed';
import { DataView } from '../models/DataView';
import { FilterCatalogFeedRequest } from '../models/FilterCatalogFeedRequest';

// Import dependency serializers (for complex types)
import { CatalogFeedSerializer } from './CatalogFeedSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterCatalogFeedRequestSerializer } from './FilterCatalogFeedRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewCatalogFeedResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewCatalogFeedResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewCatalogFeedResponse instance
   */
  static deserialize(json: string): DataviewCatalogFeedResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewCatalogFeedResponse instance
   */
  static fromObject(obj: any): DataviewCatalogFeedResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewCatalogFeedResponse');
    }


    const instance: DataviewCatalogFeedResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        CatalogFeedSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterCatalogFeedRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewCatalogFeedResponse instances
   */
  static deserializeArray(json: string): DataviewCatalogFeedResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewCatalogFeedResponse instance to a JSON string
   */
  static serialize(instance: DataviewCatalogFeedResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewCatalogFeedResponse instance to a plain object
   */
  static toObject(instance: DataviewCatalogFeedResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        CatalogFeedSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterCatalogFeedRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewCatalogFeedResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewCatalogFeedResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
